var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpensea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78079 1.72933C8.78079 1.72933 11.175 5.5875 11.175 8.91206C11.175 12.2366 9.71111 14.3655 8.64669 15.564H11.7617V17.9554H8.38128C8.38128 17.9554 6.91736 17.9582 6.91736 15.4299H0.79905C0.79905 15.4299 0.0223855 22.3472 7.46214 22.3472C14.9019 22.3472 18.5198 22.3472 18.5198 22.3472C18.5198 22.3472 20.4894 21.9477 21.8192 19.0226C23.149 16.0976 25.4092 15.8294 25.4092 15.8294V14.0554L18.8914 15.9607C18.8914 15.9607 17.827 17.8241 16.0976 17.8241C14.3683 17.8241 14.1029 17.8241 14.1029 17.8241V15.564H16.0976C16.0976 15.564 19.2909 12.7702 19.2909 9.97648C19.2909 7.18273 15.1673 3.58997 14.1029 3.32456V1.13147C14.1029 0.505669 13.5972 0 12.9714 0C12.3456 0 11.8399 0.505669 11.8399 1.13147V2.79375C11.8399 2.79375 9.3116 1.86343 8.78079 1.72933Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85028 4.25781C7.85028 4.25781 10.7781 9.44022 7.85028 13.1671C5.05653 13.1671 1.86328 13.1671 1.86328 13.1671C1.86328 13.1671 5.18784 8.64679 7.85028 4.25781Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpensea);
export default __webpack_public_path__ + "static/media/opensea.f776ba7f8f24626e52073f21fe70cdc2.svg";
export { ForwardRef as ReactComponent };